export const claimsFlowData = [
  // High-value claims with good savings
  { claimType: 'Inpatient', medicalCode: 'J0120', diagnosis: 'Pneumonia', billedAmount: 'High', savings: 'High', value: 15 },
  { claimType: 'Inpatient', medicalCode: 'J0120', diagnosis: 'Pneumonia', billedAmount: 'Medium', savings: 'Medium', value: 8 },
  { claimType: 'Inpatient', medicalCode: 'J0130', diagnosis: 'Heart Failure', billedAmount: 'High', savings: 'High', value: 12 },
  { claimType: 'Inpatient', medicalCode: 'J0130', diagnosis: 'Heart Failure', billedAmount: 'Medium', savings: 'Medium', value: 6 },
  
  // Outpatient claims
  { claimType: 'Outpatient', medicalCode: 'J0456', diagnosis: 'UTI', billedAmount: 'Low', savings: 'Low', value: 20 },
  { claimType: 'Outpatient', medicalCode: 'J0456', diagnosis: 'UTI', billedAmount: 'Medium', savings: 'Medium', value: 15 },
  { claimType: 'Outpatient', medicalCode: 'J0690', diagnosis: 'Infection', billedAmount: 'Medium', savings: 'Medium', value: 18 },
  { claimType: 'Outpatient', medicalCode: 'J0690', diagnosis: 'Infection', billedAmount: 'High', savings: 'High', value: 10 },
  
  // Emergency claims
  { claimType: 'Emergency', medicalCode: 'J0171', diagnosis: 'Trauma', billedAmount: 'High', savings: 'High', value: 25 },
  { claimType: 'Emergency', medicalCode: 'J0171', diagnosis: 'Trauma', billedAmount: 'Medium', savings: 'Medium', value: 12 },
  { claimType: 'Emergency', medicalCode: 'J0461', diagnosis: 'Cardiac', billedAmount: 'High', savings: 'High', value: 22 },
  { claimType: 'Emergency', medicalCode: 'J0461', diagnosis: 'Cardiac', billedAmount: 'Medium', savings: 'Medium', value: 14 },
  
  // Surgery claims
  { claimType: 'Surgery', medicalCode: 'J0585', diagnosis: 'Orthopedic', billedAmount: 'High', savings: 'High', value: 30 },
  { claimType: 'Surgery', medicalCode: 'J0585', diagnosis: 'Orthopedic', billedAmount: 'Medium', savings: 'Medium', value: 16 },
  { claimType: 'Surgery', medicalCode: 'J0592', diagnosis: 'Pain Management', billedAmount: 'Medium', savings: 'Medium', value: 12 },
  { claimType: 'Surgery', medicalCode: 'J0592', diagnosis: 'Pain Management', billedAmount: 'Low', savings: 'Low', value: 8 },
  
  // Diagnostic claims
  { claimType: 'Diagnostic', medicalCode: 'J0612', diagnosis: 'Imaging', billedAmount: 'Medium', savings: 'Medium', value: 14 },
  { claimType: 'Diagnostic', medicalCode: 'J0612', diagnosis: 'Imaging', billedAmount: 'Low', savings: 'Low', value: 10 },
  { claimType: 'Diagnostic', medicalCode: 'J0636', diagnosis: 'Lab Tests', billedAmount: 'Low', savings: 'Low', value: 16 },
  { claimType: 'Diagnostic', medicalCode: 'J0636', diagnosis: 'Lab Tests', billedAmount: 'Medium', savings: 'Medium', value: 8 },
  
  // Chronic condition claims
  { claimType: 'Chronic', medicalCode: 'J0650', diagnosis: 'Diabetes', billedAmount: 'Medium', savings: 'Medium', value: 20 },
  { claimType: 'Chronic', medicalCode: 'J0650', diagnosis: 'Diabetes', billedAmount: 'Low', savings: 'Low', value: 12 },
  { claimType: 'Chronic', medicalCode: 'J0736', diagnosis: 'Hypertension', billedAmount: 'Medium', savings: 'Medium', value: 18 },
  { claimType: 'Chronic', medicalCode: 'J0736', diagnosis: 'Hypertension', billedAmount: 'Low', savings: 'Low', value: 10 },
  
  // Mental health claims
  { claimType: 'Mental Health', medicalCode: 'J2060', diagnosis: 'Depression', billedAmount: 'Medium', savings: 'Medium', value: 15 },
  { claimType: 'Mental Health', medicalCode: 'J2060', diagnosis: 'Depression', billedAmount: 'Low', savings: 'Low', value: 8 },
  { claimType: 'Mental Health', medicalCode: 'J1630', diagnosis: 'Anxiety', billedAmount: 'Low', savings: 'Low', value: 12 },
  { claimType: 'Mental Health', medicalCode: 'J1630', diagnosis: 'Anxiety', billedAmount: 'Medium', savings: 'Medium', value: 6 }
];

export const claimsSummaryData = [
  { metric: 'Total Claims', value: 1250, change: '+12%' },
  { metric: 'Average Savings', value: '$2,450', change: '+8%' },
  { metric: 'High-Value Claims', value: 180, change: '+15%' },
  { metric: 'Processing Time', value: '3.2 days', change: '-10%' }
];

export const claimsByType = [
  { type: 'Inpatient', count: 320, savings: 850000 },
  { type: 'Outpatient', count: 450, savings: 420000 },
  { type: 'Emergency', count: 180, savings: 680000 },
  { type: 'Surgery', count: 95, savings: 520000 },
  { type: 'Diagnostic', count: 120, savings: 180000 },
  { type: 'Chronic', count: 85, savings: 320000 }
]; 


export const x12_837_segments = {
  ISA: "Interchange Control Header",
  GS: "Functional Group Header",
  ST: "Transaction Set Header",
  BHT: "Beginning of Hierarchical Transaction",

  Submitter: {
    NM1_41: "Submitter Name",
  },
  Receiver: {
    NM1_40: "Receiver Name",
  },

  BillingProvider: {
    HL: "Billing Provider Hierarchical Level",
    NM1_85: "Billing Provider Name",
    N3: "Billing Provider Address",
    N4: "Billing Provider City/State/ZIP",
    REF: "Billing Provider Tax ID",
    PER: "Billing Provider Contact"
  },

  Subscriber: {
    HL: "Subscriber Hierarchical Level",
    NM1_IL: "Subscriber Name",
    N3: "Subscriber Address",
    N4: "Subscriber City/State/ZIP",
    DMG: "Subscriber Demographics",
    REF: "Subscriber Secondary ID"
  },

  Patient: {
    HL: "Patient Hierarchical Level",
    NM1_QC: "Patient Name"
  },

  Claim: {
    CLM: "Claim Information",
    DTP: "Claim Date(s)",
    CL1: "Institutional Claim Codes",
    HI: "Diagnosis Codes",
    PWK: "Attachments",
    REF: "Claim Identifiers",
    NM1_Rendering: "Rendering Provider"
  },

  ServiceLines: {
    LX: "Service Line Number",
    SV1: "Service Line - Professional",
    SV2: "Service Line - Institutional",
    DTP: "Service Line Date",
    REF: "Service Line Reference"
  },

  Trailers: {
    SE: "Transaction Set Trailer",
    GE: "Functional Group Trailer",
    IEA: "Interchange Control Trailer"
  }
};
